module.exports = __webpack_public_path__ + "static/media/bg-frame-mob.2ab5ece9.svg";